import React from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../helpers";
import { toJS } from "mobx";
import { useTranslation } from "react-i18next";
import Masonry from "@mui/lab/Masonry";
import { AnalyticalInsightCard } from "./analytical-summary-card-insights";
import { AnalyticalSummaryCard } from "./survey-summary/analytical-summary-card";

const header = (index) => {
    switch (index) {
        case 0:
            return "Option";
        case 1:
            return "Voter";
        case 2:
            return "Voter%";
    }
};

// export const AnalyticalSummary = observer((props) => {
export const AnalyticalSummary = observer(() => {
    const { surveyResponseStore } = useStore();
    const { analytical_meta, analytical_data } = surveyResponseStore;
    const { t } = useTranslation("survey_management");

    let columns_def = [];

    if (!toJS(analytical_data)) return null;

    return (
        <>
            <div className="mt-4 block text-lg font-bold uppercase text-gray-800">
                {t("analytical_summary")}
            </div>

            <Masonry
                columns={{
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 3,
                    xl: 4,
                }}
                spacing={3}
            >
                {analytical_meta.map((response) => {
                    const { key, title } = response;
                    const table_data = analytical_data[key];
                    try {
                        columns_def = Object.keys(table_data[0]).map((x, index) => {
                            if (index == 2) {
                                return {
                                    Header: header(index),
                                    accessor: x,
                                };
                            } else {
                                return {
                                    Header: header(index),
                                    accessor: x,
                                    Footer:
                                        index === 0
                                            ? "Total"
                                            : surveyResponseStore.get_total_surveys(table_data, x),
                                };
                            }
                        });
                    } catch (e) {}

                    return (
                        <AnalyticalSummaryCard
                            key={key}
                            title={title}
                            tableData={table_data}
                            columns={columns_def}
                            onRowClick={(x) => {
                                surveyResponseStore.update_new_filters(
                                    key,
                                    x["key"],
                                    `${title}: ${x["key"]}`
                                );
                            }}
                        />
                        // <AnalyticalInsightCard
                        //     key={key}
                        //     title={title}
                        //     data={table_data}
                        //     // onRowClick={(x) => {
                        //     //     surveyResponseStore.update_new_filters(key, x.key, `${title}: ${x.key}`);
                        //     // }}
                        //     onRowClick={async (x) => {
                        //         console.log("Clicked Row:", x);
                        //         surveyResponseStore.update_new_filters(key, x.key, `${title}: ${x.key}`);
                        //
                        //         await surveyResponseStore.getFieldReport(
                        //             surveyResponseStore.currentReportPayload
                        //         );
                        //     }}
                        // />
                    );
                })}
            </Masonry>
        </>
    );
});
